import { render, staticRenderFns } from "./CompositeProductMinicartModal.vue?vue&type=template&id=723e259c&scoped=true&"
import script from "./CompositeProductMinicartModal.vue?vue&type=script&lang=js&"
export * from "./CompositeProductMinicartModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723e259c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
